@if (exhibitor?.downloads) {
<section class="exhibitordownlaods">
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-downloads"> Downloads </h2>
        <hr />
        <planone-download-list
          [downloads]="exhibitor?.downloads"
          [exhibitorName]="exhibitor?.name"
          [exhibitorId]="exhibitor?.id"
          [fairId]="exhibitor?.fair_id"
          (downloadClick)="
            trackDownload($event.element, $event.download.name ?? $event.download.file_name ?? $event.download.path)
          "></planone-download-list>
      </div>
    </div>
  </div>
</section>
}
